import { isSafari } from 'react-device-detect';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { WorksheetBaseProps } from 'html-worksheets/@types';
import PageLines from '../@common/PageLines';
import BaseInput from '../@common/BaseInput';
import LandscapePaperLayout from '../@common/landscape/LandscapePaperLayout';
import { translate } from '../../translations/translator';

const t = key => translate('worksheet', key);

type MyNameProps = WorksheetBaseProps & {
  valueMap: { [key: string]: string };
  isOneLine?: boolean;
  isWide?: boolean;
  isExtraWide?: boolean;
  noFooterText?: boolean;
  printRef?: React.RefObject<HTMLDivElement>;
};

const MyName = ({
  onChange,
  valueMap,
  isOneLine,
  isWide,
  isExtraWide,
  noFooterText,
  printRef
}: MyNameProps) => {
  let fontSize = isOneLine ? 100 : 65;
  let letterSpacing = isOneLine ? 15 : 10;
  let marginTopLine = isOneLine ? '-86px' : '-37px';
  let marginTopInput = isOneLine ? '-103px' : '-49px';
  if (isExtraWide) {
    fontSize = 86;
    marginTopLine = '-50px';
    marginTopInput = '-64px';
    letterSpacing = 14;
  }

  const classes = useStyles({
    fontSize,
    letterSpacing,
    isOneLine,
    marginTopLine,
    marginTopInput,
    isSafari
  });

  const handleChange = ({ target }) => {
    const singleInputKey = 1;
    onChange({
      [singleInputKey]: target.value
    });
  };

  return (
    <LandscapePaperLayout noFooterText={noFooterText} isWide={isWide} printRef={printRef}>
      <Box display="flex" flexDirection="column" justifyContent="space-evenly" flex={1}>
        <Typography
          variant="h1"
          style={{
            display: 'flex',
            alignSelf: 'center',
            fontFamily: 'FF-HWTFuturaBold',
            fontSize: 20,
            marginTop: -20,
            paddingBottom: isOneLine ? '0px' : '20px'
          }}
        >
          {isOneLine ? t('MYNAME') : t('myName')}
        </Typography>
        <Box>
          <Typography variant="h2" style={{ fontFamily: 'FF-HWTFuturaBold', fontSize: 20 }}>
            {t('myTurn')}
          </Typography>
          <PageLines
            isOneLine={isOneLine}
            style={{ paddingTop: isOneLine ? '120px' : '50px' }}
            width={1000}
            isWide={isWide}
            isExtraWide={isOneLine}
            paddingTop={isExtraWide ? 40 : 0}
          >
            <BaseInput
              printGray
              color="#767676"
              showBackground={true}
              onChange={handleChange}
              fontFamily="Print-Wide-Book"
              placeholder={t('name')}
              fontSize={fontSize}
              className={classes.input}
              value={valueMap[1]}
              marginTop={marginTopInput}
            />
          </PageLines>
        </Box>
        <Box style={{ marginTop: '50px', fontSize: '20px' }}>
          <Typography
            variant="h2"
            style={{
              fontFamily: 'FF-HWTFuturaBold',
              fontSize: 20,
              paddingBottom: isOneLine ? '100px' : '50px'
            }}
          >
            {t('yourTurn')}
          </Typography>
          <PageLines
            isOneLine={isOneLine}
            width={1000}
            isWide={!isOneLine}
            isExtraWide={isOneLine}
            paddingTop={isExtraWide ? 40 : 0}
          >
            <Typography id="print-gray" className={classes.lines}>
              {valueMap[1]}
            </Typography>
          </PageLines>
        </Box>
        <Box style={{ marginTop: '50px', fontSize: '20px' }}>
          <Typography
            variant="h2"
            style={{
              fontFamily: 'FF-HWTFuturaBold',
              fontSize: 20,
              paddingBottom: isOneLine ? '100px' : '50px'
            }}
          >
            {t('yourTurnAgain')}
          </Typography>
          <PageLines
            isOneLine={isOneLine}
            width={1000}
            isWide={!isOneLine}
            isExtraWide={isOneLine}
            paddingTop={isExtraWide ? 40 : 0}
          >
            <Typography id="print-gray" className={classes.lines}>
              {valueMap[1]}
            </Typography>
          </PageLines>
        </Box>
      </Box>
    </LandscapePaperLayout>
  );
};

const useStyles = makeStyles(props => ({
  container: (props: any) => ({
    display: 'flex',
    justifyContent: 'center'
  }),
  lines: ({ isOneLine, fontSize, marginTopLine, letterSpacing }: any) => ({
    display: 'flex',
    zIndex: 10,
    marginTop: marginTopLine,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
    position: 'absolute',
    background: 'transparent',
    border: 'none',
    fontFamily: 'Print-Wide-Book',
    color: '#D5D6D6',
    textTransform: isOneLine ? 'uppercase' : 'none',
    '&:focus': {
      border: 'none'
    },
    '&:active': {
      border: 'none'
    }
  }),
  input: ({ isOneLine, marginTopInput, letterSpacing }: any) => ({
    width: '1000px !important',
    marginLeft: '0px !important',
    paddingLeft: '0px',
    // marginTop: marginTopInput,
    color: '#D5D6D6 !important',
    display: 'flex',
    letterSpacing: letterSpacing,
    textTransform: isOneLine ? 'uppercase' : 'none'
  })
}));

export default MyName;
